module.exports = __webpack_public_path__ + "static/media/machixBg.c14d63ce.png";